<template>
  <div style="text-align:center;min-height:400px;">
    <div>
      <a-card>
        <div style="text-align:center;">
          <h1 class="title">{{ form.publishTitle }}</h1>
          <br/>
          <div style="height:40px;line-height:40px;background:#f3f3f3">
            <span>发布时间： {{ form.publishDate |moment('YYYY-MM-DD') }}</span>
            <span>有效期： {{ form.termOfValidity }}天</span>
          </div>
          <div style="width:100%;height:200px;text-align:center;">
            <table style="width:100%;table-layout:fixed;border:1px solid #ffcccc;margin-top:10px;" cellspacing="0" cellpadding="0" >
              <colgroup>
                <col style="width:15%">
                <col style="width:35%">
                <col style="width:15%">
                <col style="width:35%">
              </colgroup>
              <tbody>
                <tr>
                  <td style="height:35px;background:#d4ecfc" colspan="4">
                    基本信息
                  </td>
                </tr>
                <tr>
                  <td class="qtitle">编号：</td>
                  <td class="qcontent">
                    {{ form.tCode }}
                  </td>
                  <td class="qtitle">所在村级：</td>
                  <td class="qcontent">
                    {{ form.sysOrgName }}
                  </td>
                </tr>
                <tr>
                  <td class="qtitle">托管类型：</td>
                  <td class="qcontent">
                    {{ form.tType | tTypeFilter }}
                  </td>
                  <td class="qtitle">生产日期：</td>
                  <td class="qcontent">
                    {{ form.produceDate }}
                  </td>
                </tr>
                <tr>
                  <td class="qtitle">联系人：</td>
                  <td class="qcontent">
                    {{ form.contact }}
                  </td>
                  <td class="qtitle">联系电话：</td>
                  <td class="qcontent">
                    {{ form.contactNumber }}
                  </td>
                </tr>
                <tr>
                  <td class="qtitle">生产环节：</td>
                  <td class="qcontent">
                    {{ form.productLink | ProductLinkFilter }}
                  </td>
                  <td class="qtitle">托管面积：</td>
                  <td class="qcontent">
                    {{ form.area }}
                  </td>
                </tr>
                <tr>
                  <td class="qtitle">附着农作物：</td>
                  <td class="qcontent" >
                    {{ form.crops }}
                  </td>
                  <td class="qtitle">周边环境描述：</td>
                  <td class="qcontent">
                    {{ form.environment }}
                  </td>
                </tr>
                <tr>
                  <td class="qtitle">详细介绍：</td>
                  <td class="qcontent" v-html="form.details" style="word-wrap:break-word;" colspan="3">
                  </td>
                </tr>
              </tbody></table>
          </div>
        </div>
      </a-card>
    </div>
  </div>
</template>
<script>
import { LandTrustWebDetail } from '@/api/main/LandTrustManager'
export default {
    data() {
        return {
            id: '',
            form: {
                id: null,
                tCode: null,
                orgId: null,
                title: null,
                publishDate: null,
                termOfValidity: null,
                infoContent: null
            }
        }
    },
    mounted() {
        this.loadData()
    },
    filters: {
      tTypeFilter(val) {
       // eslint-disable-next-line eqeqeq
       val = val == 0 ? '全托' : '半托'
       return val
      },
      ProductLinkFilter(val) {
        if (val) {
          val = JSON.parse(val).join(',')
          // val = val.split(',');
          return val
        }
        return ''
      }
    },
    methods: {
     loadData() {
       this.id = this.$route.query.id
       LandTrustWebDetail({ id: this.id }).then(res => {
        this.form = res.data
      })
     }
    }
}
</script>
<style scoped>
  span{
    margin-right: 10px;
  }
      td{
    border-left: 1px solid #ffcccc;
    border-top: 1px solid #ffcccc;
    height: 30px;
    }
</style>
